module.exports = __webpack_public_path__ + "img/features_scoretracker_phone.54ef7d01.jpg";